import React from 'react';


export const Paragraph = props => (
  <p {...props.attributes}>
    {props.children}
  </p>
);



// WEBPACK FOOTER //
// ./src/components/slate/nodes/paragraph.js